<header class="app-topbar" id="header">
  <div class="page-container topbar-menu">
    <div class="d-flex align-items-center gap-2">
      <app-logo-box />

      <button class="sidenav-toggle-button px-2" (click)="toggleMobileMenu()">
        <i class="ri-menu-5-line fs-24"></i>
      </button>

      <button
        (click)="toggleMobileMenu()"
        class="topnav-toggle-button px-2"
        data-bs-toggle="collapse"
        data-bs-target="#topnav-menu-content"
      >
        <i class="ri-menu-5-line fs-24"></i>
      </button>
      <div class="topbar-item d-none d-md-flex px-2">
        @if (title) {
        <div>
          <h4 class="page-title fs-20 fw-semibold mb-0">{{ title }}</h4>
        </div>
        }@else{
        <div class="page-title-head d-flex align-items-center">
          <!-- <h4 class="fs-16 text-uppercase fw-bold mb-0">Welcome</h4> -->
        </div>
        }
      </div>
    </div>
    <div class="d-flex align-items-center gap-2">
      <!-- <div class="topbar-item d-flex d-xl-none">
        <button
          (click)="open(content)"
          class="topbar-link"
          data-bs-toggle="modal"
          data-bs-target="#searchModal"
          type="button"
        >
          <i class="ti ti-search fs-22"></i>
        </button>
      </div> -->

      <!-- Button Trigger Search Modal -->
      <!-- <div
        class="topbar-search text-muted d-none d-xl-flex gap-2 me-2 align-items-center"
        data-bs-toggle="modal"
        data-bs-target="#searchModal"
        type="button"
        (click)="open(content)"
      >
        <i class="ri-search-line fs-18"></i>
        <span class="me-2">Search something..</span>
      </div> -->

      <div class="topbar-item">
        <div ngbDropdown>
          <!-- <button ngbDropdownToggle class="topbar-link arrow-none" data-bs-toggle="dropdown" data-bs-offset="0,25"
          type="button" aria-haspopup="false" aria-expanded="false"> -->
          <button
            class="topbar-link arrow-none"
            data-bs-toggle="dropdown"
            data-bs-offset="0,25"
            type="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <img
              src="assets/images/flags/gb.svg"
              alt="user-image"
              class="w-100 rounded"
              height="18"
              id="selected-language-image"
            />
          </button>

          <!-- <div ngbDropdownMenu class="dropdown-menu-end">
            @for (item of languageList; track $index) {
            <a ngbDropdownItem href="javascript:void(0);" data-translator-lang="en">
              <img [src]="item.flag" alt="user-image" class="me-1 rounded" height="18" data-translator-image> <span
                class="align-middle">{{item.name}}</span>
            </a>
            }
          </div> -->
        </div>
      </div>

      <!-- <div class="topbar-item">
        <div ngbDropdown>
          <button
            ngbDropdownToggle
            class="topbar-link drop-arrow-none"
            data-bs-toggle="dropdown"
            data-bs-offset="0,25"
            type="button"
            data-bs-auto-close="outside"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i class="ri-notification-snooze-line animate-ring fs-22"></i>
            <span class="noti-icon-badge"></span>
          </button>

          <div
            ngbDropdownMenu
            class="p-0 dropdown-menu-end dropdown-menu-lg"
            style="min-height: 300px"
          >
            <div class="p-3 border-bottom border-dashed">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0 fs-16 fw-semibold">Notifications</h6>
                </div>
                <div class="col-auto">
                  <div ngbDropdown class="dropdown">
                    <a
                      ngbDropdownToggle
                      class="drop-arrow-none link-dark"
                      data-bs-toggle="dropdown"
                      data-bs-offset="0,15"
                      aria-expanded="false"
                    >
                      <i class="ti ti-settings fs-22 align-middle"></i>
                    </a>
                    <div ngbDropdownMenu class="dropdown-menu-end">
                      <a href="javascript:void(0);" ngbDropdownItem
                        >Mark as Read</a
                      >

                      <a href="javascript:void(0);" ngbDropdownItem
                        >Delete All</a
                      >

                      <a href="javascript:void(0);" ngbDropdownItem
                        >Do not Disturb</a
                      >

                      <a href="javascript:void(0);" ngbDropdownItem
                        >Other Settings</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ngx-simplebar
              class="position-relative z-2 card shadow-none rounded-0"
              style="max-height: 300px"
              data-simplebar
            >
              <div
                class="dropdown-item notification-item py-2 text-wrap active"
                id="notification-1"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-2.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-danger notification-badge"
                    >
                      <i class="ti ti-message-circle"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Glady Haid</span>
                    commented on
                    <span class="fw-medium text-body">paces admin status</span>
                    <br />
                    <span class="fs-12">25m ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-1"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-2"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-4.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-info notification-badge"
                    >
                      <i class="ti ti-currency-dollar"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Tommy Berry</span> donated
                    <span class="text-success">{{ currency }}100.00</span> for
                    <span class="fw-medium text-body"
                      >Carbon removal program</span
                    >
                    <br />
                    <span class="fs-12">58m ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-2"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-3"
              >
                <span class="d-flex align-items-center">
                  <div class="avatar-md flex-shrink-0 me-3">
                    <span
                      class="avatar-title bg-success-subtle text-success rounded-circle fs-22"
                    >
                      <iconify-icon
                        icon="solar:wallet-money-bold-duotone"
                      ></iconify-icon>
                    </span>
                  </div>
                  <span class="flex-grow-1 text-muted">
                    You withdraw a
                    <span class="fw-medium text-body">{{ currency }}500</span>
                    by <span class="fw-medium text-body">New York ATM</span>
                    <br />
                    <span class="fs-12">2h ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-3"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-4"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-7.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-secondary notification-badge"
                    >
                      <i class="ti ti-plus"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Richard Allen</span>
                    followed you in
                    <span class="fw-medium text-body">Facebook</span>
                    <br />
                    <span class="fs-12">3h ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-4"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>

              <div
                class="dropdown-item notification-item py-2 text-wrap"
                id="notification-5"
              >
                <span class="d-flex align-items-center">
                  <span class="me-3 position-relative flex-shrink-0">
                    <img
                      src="assets/images/users/avatar-10.jpg"
                      class="avatar-md rounded-circle"
                      alt=""
                    />
                    <span
                      class="position-absolute rounded-pill bg-danger notification-badge"
                    >
                      <i class="ti ti-heart-filled"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </span>
                  <span class="flex-grow-1 text-muted">
                    <span class="fw-medium text-body">Victor Collier</span>
                    liked you recent photo in
                    <span class="fw-medium text-body">Instagram</span>
                    <br />
                    <span class="fs-12">10h ago</span>
                  </span>
                  <span class="notification-item-close">
                    <button
                      type="button"
                      class="btn btn-ghost-danger rounded-circle btn-sm btn-icon"
                      data-dismissible="#notification-5"
                    >
                      <i class="ti ti-x fs-16"></i>
                    </button>
                  </span>
                </span>
              </div>
            </ngx-simplebar>

            <div
              style="height: 300px"
              class="d-flex align-items-center justify-content-center text-center position-absolute top-0 bottom-0 start-0 end-0 z-1"
            >
              <div>
                <iconify-icon
                  icon="line-md:bell-twotone-alert-loop"
                  class="fs-80 text-secondary mt-2"
                ></iconify-icon>
                <h4 class="fw-semibold mb-0 fst-italic lh-base mt-3">
                  Hey! 👋 <br />You have no any notifications
                </h4>
              </div>
            </div>

            <a
              href="javascript:void(0);"
              class="dropdown-item notification-item position-fixed z-2 bottom-0 text-center text-reset text-decoration-underline link-offset-2 fw-bold notify-item border-top border-light py-2"
            >
              View All
            </a>
          </div>
        </div>
      </div> -->
      <!-- 
      <div class="topbar-item d-none d-sm-flex">
        <div ngbDropdown>
          <button ngbDropdownToggle class="topbar-link drop-arrow-none" data-bs-toggle="dropdown" data-bs-offset="0,25"
            type="button" aria-haspopup="false" aria-expanded="false">
            <i class="ti ti-apps fs-22"></i>
          </button>
          <div ngbDropdownMenu class="dropdown-menu-end dropdown-menu-lg p-0">
            <div class="p-2">
              @for (chunk of appsChunks; track $index) {
              <div class="row g-0">
                @for (item of chunk; track $index) {
                <div class="col-4">
                  <a class="dropdown-icon-item" routerLink="#">
                    <img [src]="item.image" alt="slack">
                    <span>{{item.name}}</span>
                  </a>
                </div>
                }
              </div>
              }
            </div>
          </div>
        </div>
      </div> -->

      <!-- <div class="topbar-item d-none d-sm-flex">
        <button class="topbar-link" (click)="settingMenu()" type="button">
          <i class="ti ti-settings fs-22"></i>
        </button>
      </div> -->

      <!-- Notification Center -->
      <div class="topbar-item">
        <app-notification-center></app-notification-center>
      </div>

      <div class="topbar-item d-none d-sm-flex">
        <button
          class="topbar-link"
          (click)="changeTheme()"
          id="light-dark-mode"
          type="button"
        >
          @if (color==="light") {
          <i class="ti ti-moon fs-22"></i>
          }@else{
          <i class="ti ti-sun fs-22"></i>
          }
        </button>
      </div>

      <div class="topbar-item nav-user">
        <div ngbDropdown>
          <a
            ngbDropdownToggle
            class="topbar-link drop-arrow-none"
            data-bs-toggle="dropdown"
            data-bs-offset="0,19"
            type="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <img
              src="assets/images/users/profile.jpeg"
              width="32"
              class="rounded-circle me-lg-2 d-flex"
              alt="user-image"
            />
            <!-- <i class="ti ti-user-circle fs-22"></i> -->

            <span class="d-lg-flex flex-column d-none ms-1">
              <h5 class="my-0">{{ user?.name }}</h5>
              <div>{{ user?.default_company_name }}</div>
            </span>
            <i
              class="ti ti-chevron-down d-none d-lg-block align-middle ms-2"
            ></i>
          </a>
          <div ngbDropdownMenu class="dropdown-menu-end">
            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{ "Welcome !" | translate }}</h6>
            </div>
            
              <a
                href="javascript:void(0);"
                (click)="changePassword()"
                ngbDropdownItem
              >
                <i class="ti ti-password-user me-1 fs-17 align-middle"></i>
                <span class="align-middle">{{
                  "Change Password" | translate
                }}</span>
              </a>
         
            @if (
              user?.file_sharing_role?.name === 'ONE_MASTER' ||
              user?.file_sharing_role?.name === 'ONE_VIEWER'
            ) {
            <a
              href="javascript:void(0);"
              (click)="viewDocuments()"
              ngbDropdownItem
            >
              <i class="ti ti-file-type-doc me-1 fs-17 align-middle"></i>
              <span class="align-middle">{{ "Documents" | translate }}</span>
            </a>
            }

            @if (user?.role_id == ROLES.SUPER_ADMIN) {
            <a
              href="javascript:void(0);"
              (click)="changeCompany()"
              ngbDropdownItem
            >
              <i class="ri-community-line me-1 fs-17 align-middle"></i>
              <span class="align-middle">{{ "Company" | translate }}</span>
            </a>
            }

            <!-- <a routerLink="/dashboards/wallet" ngbDropdownItem>
              <i class="ti ti-wallet me-1 fs-17 align-middle"></i>
              <span class="align-middle"
                >Wallet :
                <span class="fw-semibold">{{ currency }}985.25</span></span
              >
            </a>

            <a href="javascript:void(0);" ngbDropdownItem>
              <i class="ti ti-settings me-1 fs-17 align-middle"></i>
              <span class="align-middle">Settings</span>
            </a>

            <a href="javascript:void(0);" ngbDropdownItem>
              <i class="ti ti-lifebuoy me-1 fs-17 align-middle"></i>
              <span class="align-middle">Support</span>
            </a> -->

            <div class="dropdown-divider"></div>

            <!-- <a href="/auth/lock-screen" ngbDropdownItem>
              <i class="ti ti-lock-square-rounded me-1 fs-17 align-middle"></i>
              <span class="align-middle">Lock Screen</span>
            </a> -->

            <a
              (click)="logout()"
              class="cursor-pointer dropdown-item active fw-semibold text-danger"
            >
              <i class="ti ti-logout me-1 fs-17 align-middle"></i>
              <span class="align-middle">Sign Out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>

<ng-template #content let-modal>
  <div class="card mb-0 w-100">
    <div class="px-3 py-2 d-flex flex-row align-items-center" id="top-search">
      <i class="ti ti-search fs-22"></i>
      <input
        type="search"
        class="form-control border-0"
        id="search-modal-input"
        placeholder="Search for actions, people,"
      />
      <button
        type="button"
        class="btn p-0"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        [esc]
      </button>
    </div>
  </div>
</ng-template>
